import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useHttpClient } from "../../hooks/http-hook";
import { Col, Button, Form, Alert, Image } from "react-bootstrap";
import { useTranslation } from "react-i18next"; // Importer useTranslation
import "./Display.css";

function Display({ program: initialProgram }) {
  const { t } = useTranslation(); // Assigner useTranslation à {t}
  const { sendRequest } = useHttpClient();
  const [program, setProgram] = useState(null);
  const { id } = useParams();
  const [messages, setMessages] = useState([]);
  const [alertVariant, setAlertVariant] = useState("success");
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
    setImagePreview(URL.createObjectURL(file));
  };

  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setProgram({
      ...program,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  useEffect(() => {
    setProgram(initialProgram);
    if (initialProgram && initialProgram.imageUrl) {
      setImagePreview(initialProgram.imageUrl);
    }
  }, [initialProgram]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessages([]);
    try {
      const formData = new FormData();
      for (const key in program) {
        formData.append(key, program[key]);
      }
      if (imageFile) {
        formData.append("image", imageFile);
      }

      const response = await sendRequest(
        process.env.REACT_APP_BACKEND_URL + `/programs/${id}`,
        "PATCH",
        formData
      );
      console.log(response);

      if (!response.ok) {
        setMessages([response.message]);
        setAlertVariant("danger");
        return;
      }

      setMessages([response.message]);
      setAlertVariant("success");
      console.log("ALERT : " + alertVariant);
    } catch (err) {
      console.log(err);
      setMessages([t("error_occurred")]);
      setAlertVariant("danger");
    }
  };

  return (
    <div className="shadow display-container">
      <h2 className="text-center">{t("display_title")}</h2>
      <p className="text-center text-muted">{t("display_description")}</p>
      <Form className="m-5" onSubmit={handleSubmit}>
        {messages.length > 0 && (
          <Alert dismissible variant={alertVariant}>
            {messages}
          </Alert>
        )}
        {/* Title */}
        <Form.Group controlId="formHorizontalTitle" className="mb-3">
          <Form.Label column sm={2}>
            {t("title")}
          </Form.Label>
          <Col sm={10}>
            <Form.Control
              type="text"
              name="title"
              placeholder={t("enter_title")}
              value={program ? program.title : ""}
              onChange={handleChange}
              required
            />
          </Col>
        </Form.Group>

        {/* Description */}
        <Form.Group controlId="formHorizontalDescription" className="mb-3">
          <Form.Label column sm={2}>
            {t("description")}
          </Form.Label>
          <Col sm={10}>
            <Form.Control
              type="text"
              name="description"
              placeholder={t("enter_description")}
              value={program ? program.description : ""}
              onChange={handleChange}
              required
            />
          </Col>
        </Form.Group>

        {/* Categorie */}
        <Form.Group controlId="formHorizontalCategorie" className="mb-3">
          <Form.Label column sm={2}>
            {t("category")}
          </Form.Label>
          <Col sm={10}>
            <Form.Select
              name="categorie"
              aria-label={t("category")}
              value={program ? program.categorie : ""}
              onChange={handleChange}
              required
            >
              <option value="" disabled>
                {t("select_category")}
              </option>
              <option value="Web Development">{t("web_development")}</option>
              <option value="Mobile Development">
                {t("mobile_development")}
              </option>
              <option value="Data Science">{t("data_science")}</option>
              <option value="Machine Learning">{t("machine_learning")}</option>
              <option value="Artificial Intelligence">
                {t("artificial_intelligence")}
              </option>
              <option value="Cybersecurity">{t("cybersecurity")}</option>
              <option value="Cloud Computing">{t("cloud_computing")}</option>
              <option value="DevOps">{t("devops")}</option>
              <option value="Game Development">{t("game_development")}</option>
              <option value="Internet of Things">{t("iot")}</option>
              <option value="Blockchain">{t("blockchain")}</option>
              <option value="Quantum Computing">
                {t("quantum_computing")}
              </option>
              <option value="Augmented Reality">
                {t("augmented_reality")}
              </option>
              <option value="Virtual Reality">{t("virtual_reality")}</option>
              <option value="Robotics">{t("robotics")}</option>
              <option value="Big Data">{t("big_data")}</option>
              <option value="Digital Marketing">
                {t("digital_marketing")}
              </option>
              <option value="UI/UX Design">{t("ui_ux_design")}</option>
              <option value="Product Management">
                {t("product_management")}
              </option>
              <option value="Project Management">
                {t("project_management")}
              </option>
              <option value="Business Analysis">
                {t("business_analysis")}
              </option>
              <option value="Quality Assurance">
                {t("quality_assurance")}
              </option>
              <option value="Human Resources">{t("human_resources")}</option>
            </Form.Select>
          </Col>
        </Form.Group>

        {/* Level */}
        <Form.Group controlId="formHorizontalLevel" className="mb-3">
          <Form.Label column sm={2}>
            {t("level")}
          </Form.Label>
          <Col sm={10}>
            <Form.Select
              name="level"
              aria-label={t("level")}
              value={program ? program.level : ""}
              onChange={handleChange}
              required
            >
              <option value="" disabled>
                {t("select_level")}
              </option>
              <option value="Beginner">{t("beginner")}</option>
              <option value="Intermediate">{t("intermediate")}</option>
              <option value="Advanced">{t("advanced")}</option>
            </Form.Select>
          </Col>
        </Form.Group>

        {/* Duration */}
        <Form.Group controlId="formHorizontalDuration" className="mb-3">
          <Form.Label column sm={2}>
            {t("duration_hours")}
          </Form.Label>
          <Col sm={10}>
            <Form.Control
              type="number"
              name="duration"
              placeholder={t("enter_duration")}
              value={program ? program.duration : ""}
              onChange={handleChange}
              required
            />
          </Col>
        </Form.Group>

        {/* Language */}
        <Form.Group controlId="formHorizontalLanguage" className="mb-3">
          <Form.Label column sm={2}>
            {t("language")}
          </Form.Label>
          <Col sm={10}>
            <Form.Select
              name="language"
              aria-label={t("language")}
              value={program ? program.language : ""}
              onChange={handleChange}
              required
            >
              <option value="" disabled>
                {t("select_language")}
              </option>
              <option value="French">{t("french")}</option>
              <option value="English">{t("english")}</option>
              <option value="Spanish">{t("spanish")}</option>
            </Form.Select>
          </Col>
        </Form.Group>

        {/* Visibility */}
        <Form.Group controlId="formHorizontalPublic" className="mb-3">
          <Form.Label column sm={2}>
            {t("visibility")}
          </Form.Label>
          <Col sm={10}>
            <Form.Check
              type="switch"
              name="is_public"
              label={program && program.is_public ? t("public") : t("private")}
              checked={program ? program.is_public : false}
              onChange={handleChange}
            />
          </Col>
        </Form.Group>

        <Form.Group controlId="formHorizontalPublic" className="mb-3">
          <Form.Label column sm={2}>
            {t("sharable")}
          </Form.Label>
          <Col sm={10}>
            <Form.Check
              type="switch"
              name="is_importable"
              label={
                program && program.is_importable ? t("public") : t("private")
              }
              checked={program ? program.is_importable : false}
              onChange={handleChange}
            />
          </Col>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>{t("image")}</Form.Label>
          <Form.Control
            type="file"
            name="image"
            onChange={handleFileChange}
            placeholder={t("upload_image_preview")}
          />
          {imagePreview && (
            <Image
              src={imagePreview}
              alt={t("program_preview")}
              className="mt-3 image-preview"
              fluid
            />
          )}
        </Form.Group>

        <Button variant="primary" type="submit">
          {t("save")}
        </Button>
      </Form>
    </div>
  );
}

export default Display;
